import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';

export const useCheckoutPageContainerStyles = makeStyles()((theme: Theme) => ({
  checkoutPageContainer: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100vh',
  },
  header: {
    padding: theme.spacing(4, 8),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(4, 3),
    },
  },
  cancelButton: {
    fontWeight: 500,
    '&&': {
      color: theme.palette.text.secondary,
    },
  },
  title: {
    marginBottom: theme.spacing(5),
  },
}));
